import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
// import Label from 'src/components/label';
// import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';
import { batch } from 'react-redux';


// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  user: icon('ic_user'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  mail: icon('ic_mail'),
  subscription: icon('ic_file'),
  product: icon('ic_product'),
  blog: icon('ic_blog'),
  contact: icon('ic_contact'),
  category: icon('ic_categories'),
  job: icon('ic_job'),
  batch: icon('ic_batch'),
  faqCategory: icon('ic_faqCategory'),
  faq: icon('ic_faq'),
  conversion: icon('ic_conversion'),
  tour: icon('ic_tour'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('overview'),
        items: [{ title: t('Dashboard'), path: paths.dashboard.root, icon: ICONS.dashboard }],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: t('management'),
        items: [
          // USER
          {
            title: t('user'),
            path: paths.dashboard.user.root,
            icon: ICONS.user,
            children: [
              { title: t('list'), path: paths.dashboard.user.list },
              { title: t('create'), path: paths.dashboard.user.new },
            ],
          },
          // CURRENCY EXCHANGE
          {
            title: t('Currency Exchange'),
            path: paths.dashboard.currencyExchange.root,
            icon: ICONS.conversion,
          },
          {
            title: t('Fobo Pro Analytics'),
            path: paths.dashboard.profileAnalytics.root,
            icon: ICONS.analytics,
            children: [
              // { title: t('list'), path: paths.dashboard.plan.list },
              { title: t('list'), path: paths.dashboard.profileAnalytics.list },
            ],
          },

          {
            title: t('Products'),
            path: paths.dashboard.plan.root,
            icon: ICONS.product,
            children: [
              // { title: t('list'), path: paths.dashboard.plan.list },
              { title: t('course list'), path: paths.dashboard.plan.courseList },

              { title: t('service list'), path: paths.dashboard.plan.serviceList },
              { title: t('create'), path: paths.dashboard.plan.new },
            ],
          },
          {
            title: t('Batches'),
            path: paths.dashboard.batches.root,
            icon: ICONS.batch,
            children: [{ title: t('list'), path: paths.dashboard.batches.list },
            { title: t('create'), path: paths.dashboard.batches.new }
            ],
          },
          {
            title: t('Invoices'),
            path: paths.dashboard.subscription.root,
            icon: ICONS.subscription,
            children: [{ title: t('list'), path: paths.dashboard.subscription.list },
              // { title: t('details'), path: paths.dashboard.subscription.details},
            ],
          },

          {
            title: t('Category'),
            path: paths.dashboard.category.root,
            icon: ICONS.category,
            children: [{ title: t('list'), path: paths.dashboard.category.list },
            { title: t('create'), path: paths.dashboard.category.new }
            ],
          },
          {
            title: t('Faq Category'),
            path: paths.dashboard.faqCategory.root,
            icon: ICONS.faqCategory,
            children: [{ title: t('list'), path: paths.dashboard.faqCategory.list },
            { title: t('create'), path: paths.dashboard.faqCategory.new }
            ],
          },
          {
            title: t('Faq'),
            path: paths.dashboard.faq.root,
            icon: ICONS.faq,
            children: [{ title: t('list'), path: paths.dashboard.faq.list },
            { title: t('create'), path: paths.dashboard.faq.new }
            ],
          },
          {
            title: t('jobs'),
            path: paths.dashboard.job.root,
            icon: ICONS.job,
            children: [{ title: t('list'), path: paths.dashboard.job.list },
              // { title: t('create'), path: paths.dashboard.category.new }
            ],
          },
          {
            title: t('Blogs'),
            path: paths.dashboard.post.root,
            icon: ICONS.blog,
            children: [
              { title: t('list'), path: paths.dashboard.post.list },
              { title: t('create'), path: paths.dashboard.post.new },
              { title: 'Authors', path: paths.dashboard.blogAuthor.list },
            ],
          },

          {
            title: t('Wait List'),
            path: paths.dashboard.email.root,
            icon: ICONS.mail,
            children: [{ title: t('list'), path: paths.dashboard.email.list }],
          },

          {
            title: t('contact'),
            path: paths.dashboard.contact.root,
            icon: ICONS.contact,
            children: [{ title: t('list'), path: paths.dashboard.contact.list }],
          },

          {
            title: 'CMS Plays',
            path: paths.dashboard.cmsPlays.root,
            icon: ICONS.tour,
            children: [
              { title: t('list'), path: paths.dashboard.cmsPlays.list },
              { title: t('create'), path: paths.dashboard.cmsPlays.new },
            ],
          },
          {
            title: 'Learner progress',
            path: paths.dashboard.learnerProgress.root,
            icon: ICONS.analytics,
            children: [{ title: t('list'), path: paths.dashboard.learnerProgress.list }],
          },
        ],
      },
      // CMS CONTENT
      // ----------------------------------------------------------------------
      {
        subheader: 'CMS Content',
        items: [
          {
            title: 'Domains',
            path: paths.dashboard.domains.root,
            icon: ICONS.category,
            children: [
              { title: t('list'), path: paths.dashboard.domains.list },
              { title: t('create'), path: paths.dashboard.domains.new },
            ],
          },
          {
            title: 'Sub-domains',
            path: paths.dashboard.subdomains.root,
            icon: ICONS.faqCategory,
            children: [
              { title: t('list'), path: paths.dashboard.subdomains.list },
              { title: t('create'), path: paths.dashboard.subdomains.new },
            ],
          },
          {
            title: 'Pricing Tiers',
            path: paths.dashboard.pricingTiers.root,
            icon: ICONS.subscription,
            children: [
              { title: t('list'), path: paths.dashboard.pricingTiers.list },
              { title: t('create'), path: paths.dashboard.pricingTiers.new },
              { title: 'Grant / waive access', path: paths.dashboard.pricingTiers.grant },
            ],
          },
          {
            title: 'Pricing Plans',
            path: paths.dashboard.pricingPlans.root,
            icon: ICONS.subscription,
            children: [
              { title: t('list'), path: paths.dashboard.pricingPlans.list },
              { title: t('create'), path: paths.dashboard.pricingPlans.new },
            ],
          },
          {
            title: 'Play platform settings',
            path: paths.dashboard.playPlatformSettings.root,
            icon: ICONS.analytics,
          },
        ],
      },
      // MARKETING SURFACES
      // ----------------------------------------------------------------------
      {
        subheader: 'Marketing',
        items: [
          {
            title: 'Home Page',
            path: paths.dashboard.homePage.root,
            icon: ICONS.dashboard,
          },
          {
            title: 'Announcement Banner',
            path: paths.dashboard.announcementBanner.root,
            icon: ICONS.analytics,
          },
          {
            title: 'FAQs',
            path: paths.dashboard.cmsFaqs.root,
            icon: ICONS.faq,
            children: [
              { title: t('list'), path: paths.dashboard.cmsFaqs.list },
              { title: t('create'), path: paths.dashboard.cmsFaqs.new },
            ],
          },
          {
            title: 'Testimonials',
            path: paths.dashboard.testimonials.root,
            icon: ICONS.user,
            children: [
              { title: t('list'), path: paths.dashboard.testimonials.list },
              { title: t('create'), path: paths.dashboard.testimonials.new },
            ],
          },
          {
            title: 'Nativity Templates',
            path: paths.dashboard.nativityTemplates.root,
            icon: ICONS.tour,
            children: [
              { title: t('list'), path: paths.dashboard.nativityTemplates.list },
              { title: t('create'), path: paths.dashboard.nativityTemplates.new },
            ],
          },
          {
            title: 'Memory framework',
            path: paths.dashboard.memorySettings.root,
            icon: ICONS.analytics,
            children: [
              { title: 'Settings', path: paths.dashboard.memorySettings.root },
              { title: 'Insights', path: paths.dashboard.memoryInsights.root },
              { title: 'Users', path: paths.dashboard.memoryInsights.users },
            ],
          },
        ],
      },
    ],
    [t]
  );

  return data;
}
